export default __webpack_public_path__ + "static/media/cosmetic.85365f07.JPG";